import { useEffect, useState } from "react";
import { Login } from "./components/login/Login.js";
import { Home } from "./components/dashboard/Home.js";
import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "./util/protectedRoute/index.js";
import { getItem } from "./util/localStorage/index.js";
import { useNavigate } from "react-router-dom";
import { PageNotFound } from "./components/Notfound.js";
import { CallList } from "./components/GPT/CallList.js";
import Header from "./common/Header.js";
import Sidebar from "./common/Sidebar.js";
import { useLocation } from "react-router";
import Footer from "./common/Footer.js";
// CSS
import "./App.css";
import "./assets/css/tokens.css";
import "./assets/css/style.css";

import { AllLead } from "./components/leads/AllLead.js";

import { AvailibilitySchedule } from "./components/avalibility/AvailibilitySchedule.js";
import { Profile } from "./components/profile/AdminProfile.js";
import { Appointments } from "./components/appointments/appointments.js";
import { ChangePassword } from "./components/changePassword/ChangePassword.js";
import UserList from "./components/users/List.jsx";
import UserInfo from "./components/users/UserInfo.jsx";
import CreateUser from "./components/users/CreateUser.jsx";
import AddSubscription from "./components/users/AddSubscription.jsx";
import Configuration from "./components/configurations/Config.jsx";
import setupAxiosInterceptors from "./service/axiosConfig.js";
// import KnowledgeBase from "./components/knowledgeBase/Index.jsx";
import { GlobalValues } from "./context/globalValues.js";
import { ShellUIProvider } from "./context/shellUI.js";
import AgentCreate from "./components/agents/AgentCreate.jsx";
import AgentList from "./components/agents/AgentList.jsx";
import AllAgentList from "./components/agents/AllAgentList.jsx";
import AgentInfo from "./components/agents/AgentInfo.jsx";
import KnowledgeBaseList from "./components/agents/KnowledgeBaseList.jsx";
import AssignNumbers from "./components/agents/AssignNumbers.jsx";
import Breadcrumbs from "./components/common/Breadcrumbs.jsx";
function App() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (getItem("safe_tek_admin_token")) {
    } else {
      navigate("/");
    }
    setupAxiosInterceptors();
  }, []);

  return (
    <GlobalValues>
      <ShellUIProvider>
        {location.pathname !== "/" ? (
          <>
            <Header />
            <Sidebar />
          </>
        ) : (
          <></>
        )}
        <Routes>
          <Route path="/" element={<Login />} />
          <Route
            path="*"
            element={
              <>
                {location.pathname !== "/" &&
                location.pathname !== "/create-company" &&
                location.pathname !== "/add-subscription" ? (
                  <Breadcrumbs />
                ) : null}
                <Routes>
                  <Route
                    path="/Home"
                    element={
                      <ProtectedRoute>
                        <Home />
                      </ProtectedRoute>
                    }
                  />

                  <Route
                    path="/leads"
                    element={
                      <ProtectedRoute>
                        <AllLead />
                      </ProtectedRoute>
                    }
                  ></Route>

                  <Route
                    path="/availibility"
                    element={
                      <ProtectedRoute>
                        <AvailibilitySchedule />
                      </ProtectedRoute>
                    }
                  ></Route>
                  <Route
                    path="/appointments"
                    element={
                      <ProtectedRoute>
                        <Appointments />
                      </ProtectedRoute>
                    }
                  ></Route>
                  <Route
                    path="/ChangePassword"
                    element={
                      <ProtectedRoute>
                        <ChangePassword />
                      </ProtectedRoute>
                    }
                  ></Route>
                  <Route
                    path="/Admin"
                    element={
                      <ProtectedRoute>
                        <Profile />
                      </ProtectedRoute>
                    }
                  >
                    {" "}
                  </Route>
                  <Route
                    path="/call-list"
                    element={
                      <ProtectedRoute>
                        <CallList />
                      </ProtectedRoute>
                    }
                  >
                    {" "}
                  </Route>
                  <Route
                    path="/company-list"
                    element={
                      <ProtectedRoute>
                        <UserList />
                      </ProtectedRoute>
                    }
                  >
                    {" "}
                  </Route>
                  <Route
                    path="/create-company"
                    element={
                      <ProtectedRoute>
                        <CreateUser />
                      </ProtectedRoute>
                    }
                  >
                    {" "}
                  </Route>
                  <Route
                    path="/company-info"
                    element={
                      <ProtectedRoute>
                        <UserInfo />
                      </ProtectedRoute>
                    }
                  >
                    {" "}
                  </Route>
                  <Route
                    path="/add-subscription"
                    element={
                      <ProtectedRoute>
                        <AddSubscription />
                      </ProtectedRoute>
                    }
                  >
                    {" "}
                  </Route>
                  <Route
                    path="/configuration"
                    element={
                      <ProtectedRoute>
                        <Configuration />
                      </ProtectedRoute>
                    }
                  >
                    {" "}
                  </Route>
                  {/* <Route
            path="/knowledge-base"
            element={<ProtectedRoute>
              <KnowledgeBase />
            </ProtectedRoute>}
          > </Route> */}
                  <Route
                    path="/agent-create"
                    element={
                      <ProtectedRoute>
                        <AgentCreate />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/agent-list"
                    element={
                      <ProtectedRoute>
                        <AgentList />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/allagentlist"
                    element={
                      <ProtectedRoute>
                        <AllAgentList />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/agent-info"
                    element={
                      <ProtectedRoute>
                        <AgentInfo />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/assign-numbers"
                    element={
                      <ProtectedRoute>
                        <AssignNumbers />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/agent-knowledgebase"
                    element={
                      <ProtectedRoute>
                        <KnowledgeBaseList />
                      </ProtectedRoute>
                    }
                  />

                  <Route path="*" element={<PageNotFound />} />
                </Routes>
              </>
            }
          />
        </Routes>
        {location.pathname !== "/" ? <Footer /> : ""}
      </ShellUIProvider>
    </GlobalValues>
  );
}

export default App;
